import React from 'react';
import GallerySlice from '../GallerySlice';
import breakPoints from 'helpers/Styles';

function GalleryTabSlice({ block }) {
  return (
    <div
      className="gallery_tab wrapper" // section_id=GALLERY
    >
      <GallerySlice block={block} />
      <style jsx>
        {`
          .gallery_tab {
            padding-top: 50px;
            margin-top: -50px;
          }
          @media (max-width: ${breakPoints.medium}) {
            .gallery_tab {
              padding-top: 0px;
            }
          }
        `}
      </style>
    </div>
  );
}

export default GalleryTabSlice;
